/**
 * SkipLink Component
 * Provides a keyboard-accessible link to skip to main content
 * Visually hidden by default, appears on focus
 */
export function SkipLink() {
	return (
		<a
			href="#main-content"
			className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4
                 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground
                 focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
			data-testid="skip-link"
		>
			Saltar al contenido
		</a>
	);
}
